export const getStyles = () => {
    const styles = {       
        visibleIcon: { 
            position: "absolute", 
            right: 10, 
            top: "7px" 
        },
    };
    return styles;
}